export const DATA_KEY = 'push-menu';
export const EVENT_KEY = `.${DATA_KEY}`;

export const EVENT_OPEN = `open${EVENT_KEY}`;
export const EVENT_COLLAPSE = `collapse${EVENT_KEY}`;

export const CLASS_NAME_SIDEBAR_MINI = 'sidebar-mini';
export const CLASS_NAME_SIDEBAR_COLLAPSE = 'sidebar-collapse';
export const CLASS_NAME_SIDEBAR_OPEN = 'sidebar-open';
export const CLASS_NAME_SIDEBAR_EXPAND = 'sidebar-expand';
export const CLASS_NAME_SIDEBAR_OVERLAY = 'sidebar-overlay';
export const CLASS_NAME_MENU_OPEN = 'menu-open';

export const SELECTOR_APP_SIDEBAR = '.app-sidebar';
export const SELECTOR_SIDEBAR_MENU = '.sidebar-menu';
export const SELECTOR_NAV_ITEM = '.nav-item';
export const SELECTOR_NAV_TREEVIEW = '.nav-treeview';
export const SELECTOR_APP_WRAPPER = '.app-wrapper';
export const SELECTOR_SIDEBAR_EXPAND = `[class*="${CLASS_NAME_SIDEBAR_EXPAND}"]`;
export const SELECTOR_SIDEBAR_TOGGLE = '[data-toggle="sidebar"]';
